import React, { useState, useEffect } from 'react'
import styles from './FluIndices.module.scss'
import regionDisplayOptions from './regionDisplayOptions'
import MapOptions from '../../components/MapOptionsBirthTrend'

const Filter = ({ headerType, filter_type }) => {
  const [activeFips, setactiveFips] = useState()
  const [getComorbFilter, setComorbFilter] = useState()
  useEffect(() => {
    fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/searchlocations`,
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            requester: JSON.stringify(window.localStorage.getItem('requester')),
          },
          body: JSON.stringify({
            category_ids:'BIRTHTREND',
            geo_type:'COUNTY',
            geo_parent:'TEST'

          }),
          withCredentials: true,
          credentials: 'include',
        }
      )
        .then((response) => response.json())
        .then((resData)=>{
          if (resData !== null && resData !== undefined) {
            if (resData.status === 200) {
              setactiveFips(resData.data)
            }
           
          }
        })},[1])

  useEffect(() => {
      fetch(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/staticdata`,
          {
            method: 'post',
            headers: {
              'Content-Type': 'application/json',
              requester: JSON.stringify(window.localStorage.getItem('requester')),
            },
            body: JSON.stringify({
              table_type:'COMORBIDITY',
              category_ids:'1'
            }),
            withCredentials: true,
            credentials: 'include',
          }
        )
          .then((response) => response.json())
          .then((resData)=>{
            if (resData !== null && resData !== undefined) {
              if (resData.status === 200) {
                setComorbFilter(resData.data)
              }
            }
          })},[1])


  return (
    <>
      <div className={styles.pageHeader}>
       {getComorbFilter!==undefined && activeFips!==undefined&&   
        <MapOptions
          getComorbFilter={getComorbFilter}
           regionDisplayOptions={headerType==='NAT'?regionDisplayOptions[0]:regionDisplayOptions[1]} 
           activeZip3={activeFips} 
           entity={'birthtrend'}
           geo_type={headerType}
           filter_type={filter_type}
            />}
      
      </div>
    </>
  )
}
export default Filter
